"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const browser_tracker_1 = require("@snowplow/browser-tracker");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const common_buoy_icons_1 = require("@buoyhealth/common.buoy-icons");
const common_buoy_input_1 = require("@buoyhealth/common.buoy-input");
const common_buoy_button_1 = require("@buoyhealth/common.buoy-button");
const common_buoy_layout_1 = require("@buoyhealth/common.buoy-layout");
const ThumbFeedback_1 = __importDefault(require("../ThumbFeedback"));
const HelpfulContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    display: inline-flex;

    > div {
      display: inline-flex;
    }

    > span {
      margin-right: 16px;
    }
  }
`;
const HelpfulText = styled_components_1.default.span `
  ${({ theme }) => theme.typography.variants.primary.small};
  color: ${({ theme }) => theme.palette.gray[60]};
`;
const StyledTextArea = (0, styled_components_1.default)(common_buoy_input_1.TextArea) `
  ${({ theme }) => theme.typography.variants.primary.small};

  .MuiOutlinedInput-root {
    border-radius: 8px;
  }

  textarea::placeholder {
    font-size: 14px;
    line-height: 20.125px;
  }
`;
const StyledPrimaryButton = (0, styled_components_1.default)(common_buoy_button_1.PrimaryButton) `
  padding: 10px;

  > span {
    font-size: 14px;
  }
`;
function HelpfulQuestion({ snowplowProps, question = "Was this information helpful?", onSubmit, onThumbClick, placeholderText = {
    positive: "What was helpful about the experience?",
    negative: "What can we do better?",
}, trackingCallback = browser_tracker_1.trackStructEvent, }) {
    const [clicked, setClicked] = (0, react_1.useState)();
    const [freeText, setFreeText] = (0, react_1.useState)("");
    const textAreaRef = (0, react_1.useRef)(null);
    const [submitted, setSubmitted] = (0, react_1.useState)(false);
    const [allDoneHere, setAllDoneHere] = (0, react_1.useState)(false);
    const focusFreeText = () => {
        textAreaRef?.current?.focus();
    };
    const submitHelpful = (helpful) => {
        if (helpful === undefined) {
            // Allow user to de-select a thumb
            return setClicked(undefined);
        }
        setClicked(helpful);
        focusFreeText();
        if (onThumbClick) {
            onThumbClick(helpful);
        }
        else {
            trackingCallback({
                category: "answer-helpfulness-vote",
                value: helpful ? 1 : 0,
                action: snowplowProps?.action || "",
                label: snowplowProps?.label,
                property: snowplowProps?.property,
            });
        }
    };
    const submitFreeTextFeedback = () => {
        setSubmitted(true);
        setTimeout(() => {
            setAllDoneHere(true);
        }, 7000);
        if (onSubmit) {
            onSubmit(clicked || false, freeText);
        }
        else if (freeText) {
            trackingCallback({
                category: "answer-helpfulness-vote-feedback",
                value: clicked ? 1 : 0,
                action: snowplowProps?.action || "",
                property: freeText,
                label: snowplowProps?.label,
            });
        }
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(common_buoy_layout_1.CollapseAndFade, { className: "BuoyUserFeedback__HelpfulQuestion", show: !allDoneHere, children: (0, jsx_runtime_1.jsxs)("div", { className: "BuoyUserFeedback__HelpfulQuestion__Container", children: [(0, jsx_runtime_1.jsxs)(HelpfulContainer, { children: [(0, jsx_runtime_1.jsx)(HelpfulText, { children: question }), (0, jsx_runtime_1.jsx)(ThumbFeedback_1.default, { disabled: submitted, onClick: submitHelpful })] }), (0, jsx_runtime_1.jsxs)(common_buoy_layout_1.CollapseAndFade, { mountOnEnter: true, onEntered: focusFreeText, show: clicked !== undefined && !submitted && !allDoneHere, children: [(0, jsx_runtime_1.jsxs)(Typography_1.default, { sx: { margin: "12px 0" }, variant: "body2", children: [clicked === true ? "Great!" : "Sorry to hear that.", " Tell us more."] }), (0, jsx_runtime_1.jsx)(StyledTextArea, { inputRef: textAreaRef, onChange: (e) => setFreeText(e.target.value), placeholder: clicked === true
                                    ? placeholderText.positive
                                    : placeholderText.negative }), (0, jsx_runtime_1.jsx)(StyledPrimaryButton, { onClick: submitFreeTextFeedback, sx: { marginTop: "20px", marginBottom: "10px", fontSize: "14px" }, children: "Submit feedback" })] }), (0, jsx_runtime_1.jsx)(common_buoy_layout_1.CollapseAndFade, { show: submitted && !allDoneHere, children: (0, jsx_runtime_1.jsxs)(Typography_1.default, { sx: {
                                margin: "12px 0",
                                display: "flex",
                                alignItems: "center",
                                columnGap: "10px",
                                paddingTop: "5px",
                            }, variant: "body2", children: [(0, jsx_runtime_1.jsx)(common_buoy_icons_1.HandshakeImage, { style: { height: "70px", flexShrink: 0 } }), "Thank you! Buoy values your feedback. The more we know about what\u2019s working \u2013 and what could improve \u2013 the better we can make our experience."] }) })] }) }) }));
}
exports.default = HelpfulQuestion;
//# sourceMappingURL=index.js.map